var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalChange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2667 9.39993L14.0001 5.93327C14.4001 5.8666 14.6001 5.73327 14.6667 5.73327L15.2667 5.39993L14.6667 4.2666L14.0667 4.53327C14.0667 4.53327 13.7334 4.6666 13.0001 4.6666C10.9334 4.6666 9.26673 3.13327 8.7334 2.59993V1.2666H7.40007V2.6666C6.86673 3.19993 5.20007 4.73327 3.1334 4.73327C2.3334 4.73327 2.00007 4.59993 1.9334 4.59993L1.40007 4.2666L0.733398 5.4666L1.3334 5.73327C1.40007 5.73327 1.60007 5.8666 2.00007 5.93327L0.733398 9.33327C0.733398 10.7999 1.9334 11.9999 3.40007 11.9999C4.86673 11.9999 6.06673 10.7999 6.06673 9.33327L4.66673 5.79993C6.20007 5.39993 7.3334 4.4666 8.00006 3.8666C8.60007 4.4666 9.80007 5.39993 11.3334 5.79993L10.0001 9.39993C10.0001 10.8666 11.2001 12.0666 12.6667 12.0666C14.0667 12.0666 15.2667 10.8666 15.2667 9.39993ZM2.1334 9.39993L3.3334 6.13327L4.5334 9.39993H2.1334ZM11.4001 9.39993L12.6001 6.13327L13.8001 9.39993H11.4001Z",
    fill: "#8D8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66676 13.4005V6.53385C8.66676 6.13385 8.4001 5.86719 8.0001 5.86719C7.6001 5.86719 7.33343 6.13385 7.33343 6.53385V13.4005H3.26676C2.86676 13.4005 2.6001 13.6672 2.6001 14.0672C2.6001 14.4672 2.86676 14.7339 3.26676 14.7339H12.7334C13.1334 14.7339 13.4001 14.4672 13.4001 14.0672C13.4001 13.6672 13.1334 13.4005 12.7334 13.4005H8.66676Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalChange);
export default __webpack_public_path__ + "static/media/legal-change.9d8a91b475f319d76babd0c24848df30.svg";
export { ForwardRef as ReactComponent };